<button
    *ngIf="!href"
    finderLinkId
    type="button"
    class="finder-button {{theme}} {{allowTracking}}"
    [ngClass]="{
        'anchor': anchor,
        'selected': selected,
        'full-width': fullWidth
    }"
    [linkId]="linkId"
    [analyticsTracking] = "analyticsTracking"
    [attr.id]="id"
    [attr.title]="title"
    [attr.aria-pressed]="selected"
    [attr.aria-controls]="ariaControls"
    [attr.aria-expanded]="ariaExpanded"
    [attr.aria-haspopup]="ariaHasPopup"
    [attr.aria-label]="ariaLabel"
    [attr.aria-selected]="ariaSelected"
    [attr.disabled]="disabled ? '' : null"
    [attr.tabindex]="tabIndex"
    [attr.role]="ariaRole"
>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</button>

<a
    *ngIf="href"
    finderLinkId
    finderLocale
    type="button"
    class="finder-button {{theme}} {{allowTracking}}"
    [ngClass]="{
        'anchor': anchor,
        'fit-text': fitText,
        'full-width': fullWidth,
        'interstitialModalThirdParty triggerInterstitialModal': externalLink
    }"
    [linkId]="linkId"
    [attr.id]="id"
    [attr.title]="title"
    [attr.disabled]="disabled ? '' : null"
    [attr.aria-label]="ariaLabel"
    [attr.href]="href"
    [attr.target]="target"
    [attr.tabindex]="tabIndex"
    [attr.role]="ariaRole"
>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</a>

<ng-template #contentTpl>
    <finder-font-icon *ngIf="icon" [name]="icon" size="m"></finder-font-icon>
    <ng-content></ng-content>
</ng-template>
